<template>
<div>
    <nav class="mx-4 border-b border-gray-dark">
        <h2 class="font-bold text-xl px-4 py-4">Account</h2>
    </nav>

    <div class="mx-4 pb-12 border-b border-gray-dark">
        <!-- <div class="mt-6 w-11/12 md:w-1/2 mx-auto">
            <h3 class="font-bold">You</h3>
            <p class="text-gray-darker text-sm">Bird's-eye view of your account.</p>
        </div> -->

        <div class="mt-6 w-11/12 md:w-1/2 mx-auto">
            <div class="w-20">
                <img :src="user.avatar_url" :alt="user.name" class="w-full rounded-md my-2 border border-gray-dark">
            </div>
            <p class="font-bold">{{ user.name }}</p>
            <p>{{ user.email }}</p>
            <p class="text-sm">Since {{ user.since }}</p>
        </div>
    </div>

    <div class="mx-4 pb-12 border-b border-gray-dark">
        <div class="mt-6 w-11/12 md:w-1/2 mx-auto">
            <h3 class="font-bold">Accounts</h3>
            <p class="text-gray-darker text-sm">Summary of all your connected accounts.</p>
        </div>

        <div class="mt-6 w-11/12 md:w-1/2 mx-auto">
            <div v-for="secondary in user.owned" :key="secondary.id">
                <div class="p-2 my-1 truncate flex items-center" :title="secondary.email">
                    <img :src="secondary.avatar_url" class="flex-shrink-0 w-12 rounded-md m-2 border border-gray-dark">
                    <div class="ml-2 text-sm">
                        <p class="font-bold">
                            {{ secondary.name }}
                            <span class="rounded bg-primary p-1 text-xs text-white" v-if="!secondary.is_owned">Primary</span>
                            <span class="rounded bg-gray-darker p-1 text-xs text-white" v-if="user.id === secondary.id">Active</span>
                        </p>
                        <p>{{ secondary.email }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="mx-4 pb-12">
        <div class="mt-6 w-11/12 md:w-1/2 mx-auto">
            <h3 class="font-bold">Delete Account</h3>
            <p class="text-gray-darker text-sm" v-if="!user.is_owned">
                This action deletes this and all the connected accounts (total {{ user.owned.length}} inboxes), and cannot be undone.
            </p>
            <p class="text-gray-darker text-sm" v-else>
                This action deletes and removes this inbox (<strong>{{ user.email }}</strong>) from the primary account.
            </p>
            <delete-account-button class="mt-4 py-2 px-4 rounded-md bg-destructive text-white font-bold"></delete-account-button>
        </div>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            user: User,
        }
    },
}
</script>